<template>
  <b-modal
    id="addDocumentModal"
    ref="addDocumentModal"
    title="Adicionar novo documento"
    size="lg"
    centered
    @hide="clear"
  >
  <div class="row">
    <div class="col-md-3">
      <label for="txtCaixaPasta">{{$lang.archiveDocumentsManagement.addDocument.labelCaixaPasta}}:</label>
      <div class="input-group">
        <b-form-input
          type="text"
          name="txtCaixaPasta"
          v-model="form.caixaPasta.value"
          :required="form.nome.required"
          :state="form.nome.state"
        />
      </div>
    </div>
    <div class="col-md-9">
      <label for="txtNome"><small v-show="form.nome.required" class="text-danger">*</small> {{$lang.archiveDocumentsManagement.addDocument.labelNome}}:</label>
      <div class="input-group">
        <b-form-input
          type="text"
          name="txtNome"
          v-model="form.nome.value"
          :required="form.nome.required"
          :state="form.nome.state"
        />
      </div>
    </div>
    <div class="col-md-7 pt-2">
      <label for="txtJustificativa"><small v-show="form.justificativa.required" class="text-danger">*</small> {{$lang.archiveDocumentsManagement.addDocument.labelJustificativa}}:</label>
      <div class="input-group">
        <b-form-input
          type="text"
          name="txtJustificativa"
          v-model="form.justificativa.value"
          :required="form.justificativa.required"
          :state="form.justificativa.state"
        />
      </div>
    </div>
    <div class="col-md-5 pt-2">
      <label for="arquivo"><small class="text-danger">*</small> {{$lang.archiveDocumentsManagement.addDocument.labelArquivo}}:</label>
      <span
        v-if="canPreview"
        class="pointer"
        @click="preview"
      >
        <i class="fas fa-eye fa-lg text-third"/>
      </span>
      <span
        v-else-if="canDownload"
        class="pointer"
        @click="download"
      >
        <i class="fas fa-download fa-lg text-third"/>
      </span>
      <div class="input-group">
        <ZFileInput
          id="file-small"
          type="file"
          ref="formFile"
          :placeholder="$lang.archiveDocumentsManagement.addDocument.placeholderArquivo"
          lang="pt"
          v-model="form.arquivo.value"
        />
      </div>
    </div>
    <div class="col-md-4 pt-2">
      <label for="txtData"><small v-show="form.dataEnvio.required" class="text-danger">*</small> {{$lang.archiveDocumentsManagement.addDocument.labelData}}:</label>
      <div class="input-group">
        <b-form-input
          type="date"
          name="txtData"
          v-model="form.dataEnvio.value"
          :required="form.dataEnvio.required"
          :state="form.dataEnvio.state"
        />
      </div>
    </div>
    <div class="col-md-4 pt-2">
      <label for="txtValidade"><small v-show="form.validade.required" class="text-danger">*</small> {{$lang.archiveDocumentsManagement.addDocument.labelValidade}}:</label>
      <div class="input-group">
        <b-form-input
          type="date"
          name="txtValidade"
          v-model="form.validade.value"
          :required="form.validade.required"
          :state="form.validade.state"
        />
      </div>
    </div>
    <div class="col-md-4 pt-2">
      <label for="selectStatus"><small v-show="form.status.required" class="text-danger">*</small> {{$lang.archiveDocumentsManagement.addDocument.labelStatus}}:</label>
      <div class="input-group">
        <b-form-select
          id="selectStatus"
          v-model="form.status.value"
          :options="form.status.options"
          class="mb-3"
        >
          <template slot="first">
            <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
          </template>
        </b-form-select>
      </div>
    </div>
    <div class="col-md-12" v-if="document && document.historico">
      <hr/>
      <h6 class="text-third"><strong>Histórico</strong></h6>
      <table class="table table-hover" style="border: solid 1px #dcdede;  ">
        <thead class="thead-third">
          <tr>
            <th class="text-center"><span>Usuário</span></th>
            <th class="text-center"><span>Justificativa</span></th>
            <th class="text-center"><span>Status</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(obj, index) in document.historico" v-bind:key="index">
            <td class="text-center">{{obj.usuario}}</td>
            <td class="text-center">{{obj.justificativa}}</td>
            <td class="text-center">{{obj.statusDocumento}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <template #modal-footer="{ cancel }">
    <b-button variant="danger" @click="cancel()">
      <i class="fas fa-times-circle" />
      {{ $lang.archiveDocumentsManagement.addDocument.cancelTitle }}
    </b-button>
    <b-button variant="third" @click="onSave">
      <i class="fas fa-check-circle" />
      {{ $lang.archiveDocumentsManagement.addDocument.okTitle }}
    </b-button>
  </template>
  </b-modal>
</template>

<script>
import _ from 'lodash'
import { mask } from 'vue-the-mask'
import { loading, toast } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'

import DocumentsFolderRepository from '@/shared/http/repositories/business/documentsfolder'

import AddDocumentForm from './AddDocumentForm'
import AddDocumentModel from '@/shared/models/business/documentmodel.js'
import ZFileInput from '@/components/forms/ZFileInput.vue'

const imageFormats = [
  '.JPG',
  '.PNG',
  '.JPEG'
]

const acceptedFormats = [
  ...imageFormats,
  '.PDF'
]

export default {
  name: 'AddDocumentModal',
  mixins: [
    ActionsForm
  ],
  components: {
    ZFileInput
  },
  directives: {
    mask
  },
  data () {
    return {
      form: null,
      data: null,
      folder: {
        id: null
      },
      document: null,
      documentBlob: null,
      item: null
    }
  },
  computed: {
    canPreview () {
      if (this.document && this.documentBlob && acceptedFormats.includes(this.document.formatoArquivo.toUpperCase())) {
        return true
      }

      return false
    },
    canDownload () {
      if (this.document && this.documentBlob) {
        return true
      }

      return false
    }
  },
  created () {
    this.clear()
  },
  methods: {
    async show (folder, document, item) {
      loading.push()

      try {
        this.folder = folder
        this.item = item

        if (document) {
          await this.edit(document.id)
        }

        this.$refs['addDocumentModal'].show()
      } catch (error) {
        console.log(error)
      } finally {
        loading.pop()
      }
    },
    hide () {
      this.$refs['addDocumentModal'].hide()
      this.clear()
    },
    clear () {
      this.form = _.cloneDeep(AddDocumentForm)
      this.data = _.cloneDeep(AddDocumentModel)

      this.folder = {
        id: null
      }

      this.document = null
      this.documentBlob = null
      this.item = null
    },
    async edit (documentId) {
      loading.push()

      try {
        await DocumentsFolderRepository.GetDocument(this.CompanySelected, documentId)
          .then(async response => {
            if (response.data.code > 0) {
              const document = response.data.data
              const arquivo = document.nomeArquivo + document.formatoArquivo

              this.document = document
              this.onEdit(document)

              await DocumentsFolderRepository.GetDocumentFile(this.CompanySelected, documentId, {
                responseType: 'arraybuffer'
              })
                .then(response => {
                  const blob = response.data
                  const file = new File([blob], arquivo, { type: blob.type })

                  this.documentBlob = blob
                  this.form.arquivo.value = file
                })
            }
          })
      } catch (err) {
        console.log(err)
      } finally {
        loading.pop()
      }
    },
    onSave () {
      const self = this

      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        if (this.data) {
          if (this.data.id !== null && this.data.id !== '00000000-0000-0000-0000-000000000000') {
            this.onUpdate()
          } else {
            this.data.id = '00000000-0000-0000-0000-000000000000'
            this.onCreate()
          }
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    },
    onCreate () {
      loading.push()

      var request = this.createFormDataRequest()

      DocumentsFolderRepository.AddDocument(this.folder.id, request.data, request.config)
        .then((response) => {
          if (response.data.code >= 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.emitSaved()
          } else {
            toast.error(response.data.message)
          }

          this.$nextTick(() => {
            loading.close()
            this.hide()
          })
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()

      var request = this.createFormDataRequest()

      DocumentsFolderRepository.UpdateDocument(this.folder.id, this.data.id, request.data, request.config)
        .then((response) => {
          if (response.data.code >= 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.emitSaved()
          } else {
            toast.error(response.data.message)
          }

          this.$nextTick(() => {
            loading.close()
            this.hide()
          })
        })
        .catch(this.onException)
    },
    createFormDataRequest () {
      this.data.pastaID = this.folder.id
      this.data.empresaID = this.CompanySelected

      var body = new FormData()

      for (let key in this.data) {
        if (this.data[key] !== null) {
          body.append(key, this.data[key])
        }
      }

      return {
        data: body,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      }
    },
    emitSaved () {
      const event = {
        item: _.cloneDeep(this.item)
      }

      this.$emit('saved', event)
    },
    preview () {
      const format = this.document.formatoArquivo.toUpperCase()
      const contentType = imageFormats.includes(format) ? 'image/png' : 'application/pdf'
      const blob = new Blob([this.documentBlob], { type: contentType })

      this.$emit('preview', {
        item: {
          id: 'preview',
          formatoArquivo: format
        },
        blob
      })
    },
    download () {
      const blob = new Blob([this.documentBlob])
      const href = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', this.document.nomeArquivo + this.document.formatoArquivo)

      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
      URL.revokeObjectURL(href)
    }
  }
}
</script>

<style>
#add-new-document{
    font-size: 28px;
    background-color: #008144;
    outline: transparent;
    color:white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border:transparent
}
#container-destiny-select{
  display: flex;
  flex-direction: column;
}

.section-destinations{
    min-height: 100px;
}

.container-buttons-form{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.button-cancel,
.button-save{
  margin-top: 10;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

.button-cancel{
  background-color: #dedede;
  color: #747474;
}
.button-save{
  background-color: #008148;
  color: white;

}

.select-customer{
    display: flex;
    gap: 2px;
}

.select-empreendimento{
    width: 100%;
    border-color: #c0bcbc;
}

</style>



// WEBPACK FOOTER //
// src/views/private/archiveDocumentsManagement/components/AddDocument/AddDocumentModal.vue